import { render, staticRenderFns } from "./BotPageTitle.vue?vue&type=template&id=a0f09d98"
import script from "./BotPageTitle.vue?vue&type=script&lang=js"
export * from "./BotPageTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports